import React, { FC, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { COLORS } from "@constants";
import { useStyles } from "./styles";

const BG = "#15151a";
const TXT = "#e4e4ea";
const RED = "#d4163c";
const pSx = { m: 0, mb: 1.25, textAlign: "left" as const, color: TXT, fontSize: 13, lineHeight: 1.5 };
const hSx = { m: 0, mt: 1.5, mb: 1, textAlign: "left" as const, fontWeight: 700, fontSize: 14, lineHeight: 1.35, color: COLORS.title };

const DisclaimerPopup: FC = () => {
  const classes = useStyles();
  const [showPopup, setShowPopup] = useState(true);

  const handleAccept = () => {
    localStorage.setItem("popupAccepted", "true");
    setShowPopup(false);
  };

  const handleReject = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <Box className={showPopup ? classes.mainDialog : classes.hidden}>
      <Dialog
        scroll="paper"
        maxWidth="md"
        fullWidth
        open={showPopup}
        aria-labelledby="disclaimer-popup"
        PaperProps={{ ...({ "data-nosnippet": "" } as object), sx: { backgroundColor: BG, color: TXT, borderRadius: "16px", overflow: "hidden", m: 1.5, maxHeight: "calc(100% - 24px)", border: "1px solid rgba(255,255,255,.1)" } }}
      >
        <Box sx={{ flex: "none", px: 3, py: 1.25, backgroundColor: COLORS.primary, color: "black", fontFamily: "fantasy", fontSize: "1.6rem", lineHeight: 1.2 }}>
          Best Euro Girls
        </Box>
        <Box sx={{ flex: "1 1 auto", minHeight: 0, display: "flex", position: "relative", overflow: "hidden" }}>
          <Box className={classes.closeButtonMobile} onClick={handleReject}>
            <CloseIcon fontSize="large" />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0, overflowY: "auto", p: { xs: 2, md: 3 }, pr: { md: 5 } }}>
            <Typography sx={pSx}>
              BestEuroGirls, including all webpages, links and images , displays sexually explicit material. Only consenting adults are authorized beyond this page. If you are a minor (under the age of 18 years or 21 years where 18 isn't the legal age of majority), if sexually explicit material offends you or if it's illegal to view such material in your community, you MUST leave this site by clicking "LEAVE" below. By clicking "ENTER", you agree to the statement at the bottom of this page.
            </Typography>
            <Typography sx={pSx}>
              Best Euro Girls has a zero tolerance policy for child pornography or minors advertising or utilizing our site. I agree to report any illegal services or activities which violate Terms of Use. I also agree to report suspected exploitation of minors and/or human trafficking to the appropriate authorities.
            </Typography>
            <Box sx={hSx}>BY ENTERING BESTEUROGIRLS.COM YOU AGREE THAT:</Box>
            <Box component="ul" sx={{ ...pSx, pl: 2.5, mb: 0 }}>
              <li>you are an adult in your community and are at least 18 years old (21 in some countries)</li>
              <li>you agree with terms and conditions</li>
              <li>you agree that sexually explicit material is not deemed to be obscene or illegal in your community</li>
              <li>you accept full responsibility for your own actions</li>
              <li>you agree to the use of cookies</li>
            </Box>
            <Box sx={hSx}>YOU HAVE READ THIS AGREEMENT, UNDERSTOOD IT AND AGREE TO BE BOUND BY IT.</Box>
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" }, flex: "0 0 240px", backgroundImage: "url(https://www.eurogirlsescort.com/dist/images/over-18.png)", backgroundSize: "cover", backgroundPosition: "center" }} />
        </Box>
        <Box sx={{ flex: "none", display: "flex", justifyContent: "center", gap: 2, py: 1.5, px: 2, borderTop: "1px solid rgba(255,255,255,.1)", backgroundColor: BG }}>
          <Button onClick={handleAccept} variant="contained"
            sx={{ backgroundColor: RED, color: "#fff", fontWeight: 700, fontSize: 15, borderRadius: "10px", px: 4, "&:hover": { backgroundColor: "#a8102f" } }}>
            I Agree
          </Button>
          <Button onClick={handleReject} variant="contained"
            sx={{ backgroundColor: "#2b2e36", color: "#fff", fontWeight: 600, borderRadius: "10px", px: 3, "&:hover": { backgroundColor: "#3a3e48" } }}>
            Cancel
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
};

export default DisclaimerPopup;
